import script from "./TurboTradeView.vue?vue&type=script&setup=true&lang=js"
export * from "./TurboTradeView.vue?vue&type=script&setup=true&lang=js"

import "./TurboTradeView.vue?vue&type=style&index=0&id=529c4b29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529c4b29"]])

export default __exports__